// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomAuthenticator_container__2_b7j","logo":"CustomAuthenticator_logo__3ghZ8"};